import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { storyApi } from 'apis/story/storyApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import { useAppDispatch } from 'hooks/redux';
import { setEditName, setStoryName } from 'store/slices/breadcumbSlice';
import { useCookies } from 'react-cookie';
import ContentWrapper from './ContentWrapper';
import { charactersApis } from 'apis/characters/charactersApis';
import { useTranslation } from 'react-i18next';
import SupportLangContext from 'context/SupportLangContext';

/**
 * * 등장인물 편집 화면
 */

const CharacterEditPage: React.FC = () => {
  const langList = useContext(SupportLangContext);
  const dispatch = useAppDispatch();
  const [cookies] = useCookies();
  const [selectedType, setSelectedType] = useState<string>('');

  const { projectId, characterId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [data, setData] = useState<any | null>(null);

  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);
  const [conditions, setConditions] = useState<any>(null);
  const [motions, setMotions] = useState<any>(null);

  const { state } = useLocation();

  const fetchDetailData = async () => {
    console.log(`프로필 Edit:fetchDetailData `, state);

    // '등장인물'
    dispatch(setStoryName(t(`storyEpisodeID.storyTabMenuList.characters`)));
    // 왼쪽 상단, 네비게이터 처리 (스피커로 설정)
    dispatch(setEditName(state.speaker ? state.speaker : 'Unknown'));

    try {
      const conditionsRes = await charactersApis.characterLineCondition(
        cookies.lang,
      );
      const motionsRes = await charactersApis.characterMotions(
        projectId,
        state.speaker,
      );
      setMotions(motionsRes.data);
      setConditions(conditionsRes.data);
      // setData(detailData);
      setData(state.record);
      setSupportLangList(langList);
    } catch (err) {
      console.log('fecth data error:', err);
    }
  };

  useEffect(() => {
    fetchDetailData();
  }, []);

  return (
    <>
      <DefaultLayout>
        <Wrapper>
          <ContentWrapper
            data={data}
            langList={supportLangList}
            setData={setData}
            conditions={conditions}
            motions={motions}
            setSelectedType={setSelectedType}
            selectedType={selectedType}
            projectId={projectId}
          />
        </Wrapper>
      </DefaultLayout>
    </>
  );
};

export default CharacterEditPage;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 8rem;
  }
`;
